import Vue from 'vue'
import searchClient from '@/api/sfx.js'
import { normalizePseItemSearchResult } from '@/utils/catalogue.js'

// mutation types
const SET_RESULTS = 'SET_RESULTS'
const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT'
const SET_CONTINUATION_TOKEN = 'SET_CONTINUATION_TOKEN'
const APPEND_RESULTS = 'APPEND_RESULTS'
const SET_LOADING = 'SET_LOADING'
const SET_LOADING_NEW_SEARCH = 'SET_LOADING_NEW_SEARCH'
const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'

// initial state
const state = {
  results: [],
  totalCount: null,
  loading: false,
  loadingNewSearch: true, // So we don't get a glimpse of the 'no sfx found' message on the initial load of the Search page.
  continuationToken: null, // Used for pagination
  searchQuery: ''
}

// getters
const getters = {
  searchQuery: (state) => {
    return state.searchQuery
  },

  loading: (state) => {
    return state.loading
  },

  loadingNewSearch: (state) => {
    return state.loadingNewSearch
  },

  cleanSearchParams: (state) => {
    return {
      query: state.searchQuery,
      continuationToken: state.continuationToken
    }
  }
}

// actions
const actions = {
  doSearch: (context) => {
    return searchClient.searchPseSfx(context.getters.cleanSearchParams).then(response => {
      const mutation = context.state.continuationToken === null ? SET_RESULTS : APPEND_RESULTS
      context.commit(mutation, response.data.sounds.map(sfx =>
        normalizePseItemSearchResult(sfx)
      ))
      context.commit(SET_TOTAL_COUNT, response.data.meta.totalCount)
      context.commit(SET_CONTINUATION_TOKEN, response.data.continuationToken)
      if (context.state.results.length > 0) {
        context.dispatch('player/loadTracks', context.state.results, { root: true })
      }
    })
  },

  resetSearch: (context) => {
    context.commit(SET_RESULTS, [])
    context.commit(SET_CONTINUATION_TOKEN, null)
    context.commit(SET_SEARCH_QUERY, '')
    context.commit(SET_LOADING_NEW_SEARCH, true) // Stop we-couldn't-find-anything message.
  },

  setContinuationToken: (context, value) => {
    context.commit(SET_CONTINUATION_TOKEN, value)
  },

  setSearchQuery: (context, value) => {
    context.commit(SET_SEARCH_QUERY, value)
  },

  setLoading: (context, value) => {
    context.commit(SET_LOADING, value)
  },

  setLoadingNewSearch: (context, value) => {
    context.commit(SET_LOADING_NEW_SEARCH, value)
  }
}

// mutations
const mutations = {
  [SET_RESULTS]: (state, items) => {
    Vue.set(state, 'results', items)
  },

  [SET_TOTAL_COUNT]: (state, value) => {
    Vue.set(state, 'totalCount', value)
  },

  [APPEND_RESULTS]: (state, items) => {
    state.results.push(...items)
  },

  [SET_CONTINUATION_TOKEN]: (state, value) => {
    Vue.set(state, 'continuationToken', value)
  },

  [SET_SEARCH_QUERY]: (state, value) => {
    Vue.set(state, 'searchQuery', value)
  },

  [SET_LOADING]: (state, payload) => {
    state.loading = payload
  },

  [SET_LOADING_NEW_SEARCH]: (state, payload) => {
    state.loadingNewSearch = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
